import UnderlinedText from "./underlined_text";
import { fieldHeader } from "../../../../components/fields/field_header";
import { Grid, Typography } from "@mui/material";

const ViewStoreAdGroupInformation = ({ data }: any) => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" color={"white"} bgcolor={"red"} p={0.5}>
          STORE AD GROUP INFORMATION:
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Name of Ad Group", false)}</Grid>
        <UnderlinedText text={data.adGroupName} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Ad Group Manager", false)}</Grid>
        <UnderlinedText text={data.adGroupManager} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Digital Circulars", false)}</Grid>
        <UnderlinedText text={data.digitalCirculars} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Print Circular", false)}</Grid>
        <UnderlinedText text={data.printCircular} />
      </Grid>
      <Grid item xs={12}>
        <Grid item>{fieldHeader("# Print Ads Weekly", false)}</Grid>
        <UnderlinedText text={data.numPrintAdsWeekly} />
      </Grid>
    </>
  );
};

export default ViewStoreAdGroupInformation;
